export const setCriteria = (criteria) => ({
  type: "SET_CRITERIA",
  criteria,
});
